import * as Yup from "yup";

// Expresion regular de RFC sincronizada con ConfigBillSchema.js y validateOperatorFields.js
export const RFC_REGEX = /^([A-Z,Ñ,&]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[A-Z|\d]{3})$/;

export function getOperatorSchema() {
  return Yup.object().shape({
    figure_type: Yup.string().required("Selecciona el tipo de figura"),
    figure_rfc: Yup.string()
      .required("Campo requerido")
      .matches(RFC_REGEX, "El RFC no tiene un formato válido"),
    license_number: Yup.string().required("Ingresa el número de licencia"),
  });
}
